import { SupportedLanguage } from '@estercare/ester-shared'
import { appConfig } from '../../../../config'

export const postEmailTestTemplate = async ({
  templateName,
  language,
  accessToken,
}: {
  templateName: string
  language: SupportedLanguage
  accessToken: string
}): Promise<Response> => {
  const response = await fetch(`${appConfig.serverRootUrl}/api/private/test/send-email`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ templateName, language }),
  })
  if (!response.ok) {
    throw new Error(`Failed to send email`)
  }
  return response
}
